import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faSms } from "@fortawesome/free-solid-svg-icons"; // Import Call and SMS icons
import { faTwitter, faInstagram } from "@fortawesome/free-brands-svg-icons"; // Import Twitter and Instagram icons

import INFO from "../../data/user";

import "./styles/socials.css";

const Socials = () => {
	return (
		<div className="socials">
			<div className="social">
				<a href={INFO.socials.twitter} target="_blank" rel="noreferrer">
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faTwitter} // Twitter icon
							className="social-icon"
						/>
					</div>
					<div className="social-text">Follow on Twitter</div>
				</a>
			</div>

			{/* Replace GitHub with SMS */}
			<div className="social">
				<a href={`sms:+250781578901`} target="_blank" rel="noreferrer">
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faSms} // SMS icon
							className="social-icon"
						/>
					</div>
					<div className="social-text">Send an SMS</div>
				</a>
			</div>

			{/* Replace LinkedIn with Call */}
			<div className="social">
				<a href={`tel:+250781578901`} target="_blank" rel="noreferrer">
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faPhone} // Phone (Call) icon
							className="social-icon"
						/>
					</div>
					<div className="social-text">Call Me</div>
				</a>
			</div>

			<div className="social">
				<a
					href={INFO.socials.instagram}
					target="_blank"
					rel="noreferrer"
				>
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faInstagram} // Instagram icon
							className="social-icon"
						/>
					</div>
					<div className="social-text">Follow on Instagram</div>
				</a>
			</div>

			<div className="email">
				<div className="email-wrapper">
					<a
						href={`mailto:${INFO.main.email}`}
						target="_blank"
						rel="noreferrer"
					>
						<div className="social-icon">
							<FontAwesomeIcon icon={faEnvelope} />
						</div>

						<div className="social-text">{INFO.main.email}</div>
					</a>
				</div>
			</div>
		</div>
	);
};

export default Socials;
